module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANlJREFUSEvtlbEOAUEQhv+5i07lFVy0kl2FF9EqFApRCg+gE61SoZDwJCJhrnfxDkQlYgeRE45LFnfdTT3z7eTL5h9CSkURrquUGgKoEVHe8s2DiMyYuQfAhDMvYK11C0DfGNMFsLMBE1GBiAbGmI7v++M48EREiJnrNtCwRyk1B7Bn5mYceCoiR2ZufAPWWr/NRVVk4LvRT65sXGeOH5YyFf+rWAE5t1gaAZDzdtOuAKfnb/iz47XnVR24ixvMIVMtB8EyEXASG6cWm+kE/fV6pHOabALHtucCWkE6JgtrsGAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/home/popup-phone.png
// module id = CMFj
// module chunks = 1